// util functions for looking up display options
import displayOptionsJSON from './display-options.json';

const getDisplayOptionForValue = (fieldId, value) => {
  // This should not read directly from the jason
  // instead the logic that gets keys and generated keys from the json needs to be
  // refactored so it can be shared between lookup and getDisplayOptions
  // in the meantime however, we just go directly to the jason with a fieldId
  const options = displayOptionsJSON[fieldId];
  if (!options) { return null; }
  return options.find((option) => option.value === value);
};


const getDisplayOptionTextForValue = (fieldId, value) => {
  const option = getDisplayOptionForValue(fieldId, value);
  if (!option) { return null; }
  return option.text;
};

export {
  getDisplayOptionForValue,
  getDisplayOptionTextForValue,
};
